import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StyledContainers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  width: 100%;
  justify-content: space-between;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
  }
`;

export const StyledHeaderTitleWithIcon = styled.div`
  display: flex;
  gap: 0.8rem;
  font-size: 2.4rem;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.info.main};
`;

export const StyledFooter = styled.div`
  display: block;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  padding: 1.8rem;
  width: 100%;
  background: ${({ theme }) => theme.colors.info.lightest};
  color: ${({ theme }) => theme.colors.text.main};
  border-radius: 0.5rem;
  margin-top: 0.8rem;
  text-align: center;
`;
